import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useRef } from "react";
import { useTranslations } from "next-intl";
import { Button, Ui } from "@silvertours/front-shared";
import { UiLegacy, OptimizationLegacy } from "@silvertours/front-legacy-shared";
import { HostLegacy } from "@silvertours/front-legacy-entities";
import { Container, FormContainer, Headline, ImageWrapper, LegalText } from "./NewsletterRegistration.styles";
var NewsletterSignup = function(param) {
    var showImage = param.showImage, showTitle = param.showTitle, showHeadline = param.showHeadline, onSubmit = param.onSubmit;
    var t = useTranslations("features.newsletterRegistrationLegacy.newsletterRegistration");
    var formatImage = HostLegacy.useHost().formatImage;
    var inputRef = useRef(null);
    var handleSubmit = function() {
        var _ref = _async_to_generator(function(event) {
            return _ts_generator(this, function(_state) {
                event.preventDefault();
                if (inputRef.current) {
                    onSubmit(inputRef.current.value);
                }
                return [
                    2
                ];
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            showTitle && /*#__PURE__*/ _jsx(UiLegacy.SectionTitle, {
                children: t("title")
            }),
            /*#__PURE__*/ _jsxs(Container, {
                children: [
                    showImage && /*#__PURE__*/ _jsx(ImageWrapper, {
                        children: /*#__PURE__*/ _jsx(OptimizationLegacy.ResponsiveImage, {
                            src: formatImage(t("imageSource")),
                            alt: "Email",
                            width: 300,
                            height: 300
                        })
                    }),
                    /*#__PURE__*/ _jsx("form", {
                        method: "post",
                        id: "newsletter-form",
                        onSubmit: handleSubmit,
                        children: /*#__PURE__*/ _jsxs(FormContainer, {
                            children: [
                                showHeadline && /*#__PURE__*/ _jsx(Headline, {
                                    children: t("headline")
                                }),
                                /*#__PURE__*/ _jsx(Ui.Input, {
                                    ref: inputRef,
                                    type: "email",
                                    id: "newsletter-email",
                                    name: "email",
                                    label: t("label"),
                                    autoComplete: "email",
                                    autoCorrect: "off",
                                    autoCapitalize: "off",
                                    required: true
                                }),
                                /*#__PURE__*/ _jsx(LegalText, {
                                    dangerouslySetInnerHTML: {
                                        __html: t.raw("legalText")
                                    }
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "submit",
                                    fullWidth: true,
                                    children: t("buttonText")
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
export { NewsletterSignup };
